import { createContext, PropsWithChildren } from 'react';
import { UseFormReturn, type FieldValues } from 'react-hook-form';
import { FormProvider } from '../forms/FormProvider';
import { ModelContext } from './ModelProvider';
import { useRhinoDevtoolsEmit } from '../../hooks/dev';
import { RhinoResource } from '../../index';

// Dynamic controller-state bag; consumers read many runtime fields.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModelCreateContextValue = Record<string, any>;

export const ModelCreateContext = createContext<
  ModelCreateContextValue | undefined
>(undefined);

interface ModelCreateProviderProps<T extends FieldValues> {
  methods: UseFormReturn<T>;
  model?: RhinoResource;
  [key: string]: unknown;
}

export const ModelCreateProvider = <T extends FieldValues>({
  children,
  ...props
}: PropsWithChildren<ModelCreateProviderProps<T>>) => {
  const { methods, ...context } = props;
  const { model } = context;

  useRhinoDevtoolsEmit({ type: 'ModelCreateContext', context });

  return (
    <ModelContext value={{ model }}>
      <ModelCreateContext value={{ ...props }}>
        <FormProvider {...methods}>{children}</FormProvider>
      </ModelCreateContext>
    </ModelContext>
  );
};
